/**
 * PromocaoCollection
 *
 * @author Simpli CLI generator
 */
import {PageCollection, HttpExclude, Request} from 'simpli-web-sdk'
import {Promocao} from '@/model/resource/Promocao'

/* TODO: review generated class */
@HttpExclude()
export class PromocaoCollection extends PageCollection<Promocao> {
  constructor() {
    super(Promocao)
  }

  queryAsPage() {
    return this.listPromocao()
  }

  async listPromocao() {
    return await Request.get(`/admin/promocao`, {params: this.params})
      .name('listPromocao')
      .as(this)
      .getResponse()
  }

  async listCsvPromocao() {
    return await Request.get(`/admin/promocao/csv`, {params: this.params})
      .name('listCsvPromocao')
      .as(this)
      .getResponse()
  }
}
